const baseText = 'Ad'
const mainHeaderConfig = {
  baseText,
  selectedLabel: `${baseText}s Selected`,
  normSelectedLabel: `Norm ${baseText}s Selected`
}

export default mainHeaderConfig



// WEBPACK FOOTER //
// ./src/app/configuration/Template/config/components/generic/MainHeader.js